import gql from 'graphql-tag';

const PersonalAccQuery = {
  configValueList: gql`
    query configValueList(
      $invite_bonus_inviter: Boolean!
      $invite_bonus_invited: Boolean!
      $api_yandex_key: Boolean!
      $dadata_api_key: Boolean!
      $install_mobile_app_title: Boolean!
      $install_mobile_app_text: Boolean!
      $invite_acl: Boolean!
      $qr_code_enable: Boolean!
      $miadzaki_forever: Boolean!
      $tinkoff_auth_partner: Boolean!
      $force_yandex_metrika: Boolean!
      $default_delivery_morning_start: Boolean!
      $default_delivery_morning_end: Boolean!
      $default_delivery_evening_start: Boolean!
      $default_delivery_evening_end: Boolean!
    ) {
      courier_oferta: configValue(name: "courier_oferta") {
        value
      }

      cashback_for_pickup: configValue(name: "cashback_for_pickup") {
        value
      }

      invite_bonus_inviter: configValue(name: "invite_bonus_inviter")
        @include(if: $invite_bonus_inviter) {
        value
      }

      invite_bonus_invited: configValue(name: "invite_bonus_invited")
        @include(if: $invite_bonus_invited) {
        value
      }
      api_yandex_key: configValue(name: "api_yandex_key")
        @include(if: $api_yandex_key) {
        value
      }
      dadata_api_key: configValue(name: "dadata_api_key")
        @include(if: $dadata_api_key) {
        value
      }
      install_mobile_app_title: configValue(name: "install_mobile_app_title")
        @include(if: $install_mobile_app_title) {
        value
      }
      install_mobile_app_text: configValue(name: "install_mobile_app_text")
        @include(if: $install_mobile_app_text) {
        value
      }
      invite_acl: configValue(name: "invite_acl") @include(if: $invite_acl) {
        value
      }
      qr_code_enable: configValue(name: "qr_code_enable")
        @include(if: $qr_code_enable) {
        value
      }
      miadzaki_forever: configValue(name: "miadzaki_forever")
        @include(if: $miadzaki_forever) {
        value
      }
      tinkoff_auth_partner: configValue(name: "tinkoff_auth_partner")
        @include(if: $tinkoff_auth_partner) {
        value
      }
      force_yandex_metrika: configValue(name: "force_yandex_metrika")
        @include(if: $force_yandex_metrika) {
        value
      }
      default_delivery_morning_start: configValue(
        name: "default_delivery_morning_start"
      ) @include(if: $default_delivery_morning_start) {
        value
      }
      default_delivery_morning_end: configValue(
        name: "default_delivery_morning_end"
      ) @include(if: $default_delivery_morning_end) {
        value
      }
      default_delivery_evening_start: configValue(
        name: "default_delivery_evening_start"
      ) @include(if: $default_delivery_evening_start) {
        value
      }
      default_delivery_evening_end: configValue(
        name: "default_delivery_evening_end"
      ) @include(if: $default_delivery_evening_end) {
        value
      }
    }
  `
};

export default PersonalAccQuery;
